import React, { useState, memo } from 'react';
import { Info } from 'lucide-react';
interface InfoTooltipProps {
  content: string;
  className?: string;
}
export const InfoTooltip = memo(function InfoTooltip({
  content,
  className = ''
}: InfoTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="relative inline-block" data-id="element-1553">
      <button type="button" onClick={() => setIsOpen(!isOpen)} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors ${className}`} aria-label="Más información" data-id="element-1554">
        <Info className="h-3 w-3" data-id="element-1555" />
      </button>

      {isOpen && <div className="absolute z-50 w-80 p-4 mt-2 bg-blue-50 border border-blue-300 rounded-2xl shadow-sm left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-0" data-id="element-1556">
          <div className="text-xs text-blue-800 leading-relaxed font-normal" data-id="element-1557">
            {content}
          </div>
          <div className="absolute -top-[5px] left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-4 w-3 h-3 bg-blue-50 border-l border-t border-blue-300 transform rotate-45" data-id="element-1558"></div>
        </div>}
    </div>;
});